import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76824484"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Certificazioni")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          ($data.loading)
            ? (_openBlock(), _createBlock(_component_loading_spinner, {
                key: 0,
                name: "dots"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => ($options.refreshData($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              (_ctx.articles.length>0)
                ? (_openBlock(), _createBlock(_component_ion_grid, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, articleIndex) => {
                            return (_openBlock(), _createBlock(_component_ion_col, {
                              size: "12",
                              "size-md": "12",
                              "size-lg": "6",
                              "size-xl": "4",
                              key: 'card_article_'+articleIndex
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  lines: "none",
                                  onClick: ($event: any) => ($options.openDetails(articleIndex))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_card, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_img, {
                                          alt: "Image",
                                          src: article.image_path
                                        }, null, 8, ["src"]),
                                        _createVNode(_component_ion_card_header, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_card_title, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(article.title), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_card_subtitle, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(article.subtitle), 1),
                                                _hoisted_1,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.tags, (tag, tagIndex) => {
                                                  return (_openBlock(), _createBlock(_component_ion_badge, {
                                                    style: {"margin-right":"5px","margin-top":"5px"},
                                                    key: 'tag_'+tagIndex
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(tag), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_card_content, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(article.content.replace(/(<([^>]+)>)/gi, "").substr(0, 100)) + "... ", 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}